import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { FaqSection } from "@/components/home/FaqSection";
import { CtaBand } from "@/components/CtaBand";
import { FAQS } from "@/data/content";
import { localBusinessSchema, faqSchema, breadcrumbSchema } from "@/lib/schema";

export default function FaqPage() {
  return (
    <>
      <Seo
        title="FAQ — House Cleaning Melbourne"
        description="Frequently asked questions about JK House Cleaning — service areas, hours, same-day cleaning, insurance, equipment and how to get a free quote in Melbourne."
        path="/faq"
        schema={[faqSchema(FAQS), localBusinessSchema(), breadcrumbSchema([{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq" }])]}
      />
      <PageHeader
        eyebrow="FAQ"
        title="Frequently asked questions"
        subtitle="Answers to the things Melbourne customers ask us most. Can't find what you need? Get in touch any time."
        crumbs={[{ name: "FAQ" }]}
      />
      <FaqSection limit={0} showViewAll={false} />
      <CtaBand />
    </>
  );
}
